import { AlertCircle, Bot, Building2, CheckCircle2, ChevronRight } from 'lucide-react'
import { Link } from 'react-router-dom'
import GlassCard from '../components/GlassCard'
import Skeleton from '../components/Skeleton'

function Metric({ icon: Icon, label, value, accent }) {
  return (
    <div className="flex min-w-0 items-center gap-3 rounded-xl border p-3" style={{ borderColor: 'var(--dash-border)', background: 'var(--dash-surface-subtle)' }}>
      <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-xl" style={{ background: `${accent}18`, color: accent }}>
        <Icon size={17} />
      </div>
      <div className="min-w-0">
        <p className="text-lg font-semibold tabular-nums" style={{ color: 'var(--dash-text)' }}>{value}</p>
        <p className="truncate text-[11px]" style={{ color: 'var(--dash-text-muted)' }}>{label}</p>
      </div>
    </div>
  )
}

export default function ClientHealth({ health, loading }) {
  const pending = health.pendingClients.slice(0, 4)

  return (
    <GlassCard className="overflow-hidden">
      <div className="flex flex-wrap items-center justify-between gap-3 border-b px-6 py-5" style={{ borderColor: 'var(--dash-border)' }}>
        <div>
          <h2 className="text-sm font-semibold" style={{ color: 'var(--dash-text)' }}>Saúde da operação</h2>
          <p className="mt-0.5 text-[11px]" style={{ color: 'var(--dash-text-muted)' }}>
            Acompanhe clientes que já estão prontos e os que ainda precisam de configuração.
          </p>
        </div>
        <Link to="/client-platforms" className="inline-flex items-center gap-1 text-[11px] font-medium" style={{ color: 'var(--dash-primary)' }}>
          Ver clientes <ChevronRight size={13} />
        </Link>
      </div>

      <div className="grid grid-cols-1 gap-3 p-5 sm:grid-cols-3">
        {loading ? (
          Array.from({ length: 3 }).map((_, index) => <Skeleton key={index} className="h-[68px] w-full" />)
        ) : (
          <>
            <Metric icon={Building2} value={health.stats.active ?? 0} label="clientes ativos" accent="#34FEAD" />
            <Metric icon={Bot} value={health.agents} label="agentes vinculados" accent="#AD34FE" />
            <Metric icon={AlertCircle} value={health.pendingClients.length} label="clientes sem agente" accent="#FE9F34" />
          </>
        )}
      </div>

      <div className="border-t px-6 py-4" style={{ borderColor: 'var(--dash-border)', background: 'var(--dash-surface-subtle)' }}>
        {loading ? (
          <Skeleton className="h-10 w-full" />
        ) : pending.length > 0 ? (
          <div className="flex flex-col gap-2">
            <p className="text-[10px] font-semibold uppercase tracking-[0.12em]" style={{ color: 'var(--dash-text-muted)' }}>
              Próximas configurações
            </p>
            <div className="grid grid-cols-1 gap-2 md:grid-cols-2">
              {pending.map((client) => (
                <Link key={client.id} to={`/client-platforms/${client.id}/agents`} className="group flex items-center justify-between rounded-xl border px-3 py-2.5 transition-colors hover:bg-[var(--dash-surface-hover)]" style={{ borderColor: 'var(--dash-border)', background: 'var(--dash-surface)' }}>
                  <span className="min-w-0 truncate text-xs font-medium" style={{ color: 'var(--dash-text)' }}>{client.name}</span>
                  <span className="ml-3 inline-flex shrink-0 items-center gap-1 text-[10px] font-medium" style={{ color: '#FE9F34' }}>
                    Criar agente <ChevronRight size={12} className="transition-transform group-hover:translate-x-0.5" />
                  </span>
                </Link>
              ))}
            </div>
          </div>
        ) : (
          <div className="flex items-center gap-2 text-xs" style={{ color: '#29B77F' }}>
            <CheckCircle2 size={15} />
            Todos os clientes listados já possuem pelo menos um agente.
          </div>
        )}
      </div>
    </GlassCard>
  )
}
